import { useEffect, useState } from "react";
import { fetchDictionaryApiLexicalHints, normalizeHeadwordForDictionaryApi, } from "./dictionary-api-hints";
const lexicalHintsCache = new Map();
/**
 * Fills missing part of speech and/or phonetic spelling from a public English dictionary API
 * when structured fields are absent (e.g. link-preview OG text only).
 */
export function useDictionaryLexicalHints(_headword, existing) {
    // DISABLED NETWORK FETCH: this hook was calling api.dictionaryapi.dev on
    // every dictionary block mount to fill in missing POS/phonetic spelling.
    // Disabled to keep initial load snappy. Re-enable by restoring the body
    // below; better long-term fix is to enrich at ingestion time and persist
    // partOfSpeech/phonetic onto block.content.
    //
    // const [fetched, setFetched] = useState<DictionaryLexicalHints | undefined>(undefined);
    // const hasPos = Boolean(existing.partOfSpeech?.trim());
    // const hasPhone = Boolean(existing.phonetic?.trim());
    // const canFetch = (!hasPos || !hasPhone) && headword.trim().length >= 2;
    //
    // useEffect(() => {
    //   setFetched(undefined);
    //   if (canFetch === false) {
    //     return;
    //   }
    //   const q = normalizeHeadwordForDictionaryApi(headword);
    //   if (!q) {
    //     return;
    //   }
    //   const cached = lexicalHintsCache.get(q);
    //   if (cached !== undefined) {
    //     setFetched(cached ?? undefined);
    //     return;
    //   }
    //   const ac = new AbortController();
    //   void fetchDictionaryApiLexicalHints(q, ac.signal).then((hints) => {
    //     if (ac.signal.aborted) return;
    //     lexicalHintsCache.set(q, hints ?? null);
    //     setFetched(hints);
    //   });
    //   return () => {
    //     ac.abort();
    //   };
    // }, [headword, canFetch]);
    return {
        partOfSpeech: existing.partOfSpeech?.trim() || undefined,
        phonetic: existing.phonetic?.trim() || undefined,
    };
}
